import { render, staticRenderFns } from "./look1.vue?vue&type=template&id=ac9f623a&scoped=true"
import script from "./look1.vue?vue&type=script&lang=js"
export * from "./look1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9f623a",
  null
  
)

export default component.exports